module.exports = __webpack_public_path__ + "img/_driving.018987b4.svg";